export const ExerciseSet = {
  bindings: {
    data: '<',
    workout: '<',
    exercises: '<',
    gender: '<',
    params: '<',
    onShowModal: '&',
  },

  template: `
    <div class="exercise-set">
      <div class="exercise-set-wrap p-sm-3">
        <h4 class="exercise-set-header pt-3">
          {{ $ctrl.data.name }}
          <span ng-show="$ctrl.data.show_time" class="muted"> {{ $ctrl.data.total_time }}</span>
        </h4>
        <div class="reps"
          ng-show="$ctrl.data.repsCount > 0 || $ctrl.data.note"
          ng-class="{ 'no-reps': $ctrl.data.repsCount == 0, 'no-items': $ctrl.data.items.length == 0 }">
          <h3 ng-if="$ctrl.data.repsCount > 0">
            <span class="times">&times;</span>
            {{ $ctrl.data.repsCount }}
          </h3>
          <p class="note"
            ng-class="{ large: $ctrl.data.repsCount > 9 }"
            ng-show="$ctrl.data.note"
            ng-bind-html="$ctrl.data.note">
          </p>
        </div>
        <div class="exercises">
          <exercise
            ng-repeat="item in $ctrl.data.items track by $index"
            index="$index"
            data="item"
            workout="$ctrl.workout"
            exercise="$ctrl.exercises[item.exerciseId]"
            gender="$ctrl.gender"
            params="$ctrl.params"
            class="exercise-wrap"
            on-click="$ctrl.onShowModal({ item: item })">
          </exercise>
        </div>
      </div>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Exercise/ExerciseSet.js